export var DelayedPromptType;
(function (DelayedPromptType) {
    DelayedPromptType["Native"] = "native";
    DelayedPromptType["Push"] = "push";
    DelayedPromptType["Category"] = "category";
    DelayedPromptType["Sms"] = "sms";
    DelayedPromptType["Email"] = "email";
    DelayedPromptType["SmsAndEmail"] = "smsAndEmail"; // sms and email only
})(DelayedPromptType || (DelayedPromptType = {}));
//# sourceMappingURL=Prompts.js.map